<script>
import {
  MapAgentStationStatus,
  MapGender,
  MapVisionDisease,
  MapEyeAcuityLogmar,
  MapTreatmentStage,
  MapRoles,
  MapEmployeeRoles
} from "@/common/util";
// import intPage from "@/mixin/intPage.js";
import PagenationContainer from "@/components/common/PagenationContainer.vue";
import quit from "@/common/quit";

import xorBy from "lodash/xorBy";
import cloneDeep from "lodash/cloneDeep";
import moment from "moment";

export default {
  components: {
    PagenationContainer
  },
  data() {
    const ROLE_SUPER_ADMIN =
      localStorage.getItem("roles").indexOf("ROLE_SUPER_ADMIN") > -1;
    const ROLE_AGENT =
      localStorage.getItem("roles").indexOf("ROLE_AGENT") > -1 &&
      !(localStorage.getItem("roles").indexOf("ROLE_AGENT_OPTOMETRIST") > -1);
    const ROLE_REGION_MANAGER =
      localStorage.getItem("roles").indexOf("ROLE_REGION_MANAGER") > -1;
    const ROLE_STATION_MANAGER =
      localStorage.getItem("roles").indexOf("ROLE_STATION_MANAGER") > -1;
    let tableButtonArray1 = [
      {
        text: "解除关联",
        key: "remove"
      }
    ];
    let newEmployeeRoles = [
      {
        label: "医生",
        keyName: "ROLE_DOCTOR"
      },
      {
        label: "视觉训练师",
        keyName: "ROLE_AGENT_OPTOMETRIST"
      }
    ];
    let tableButtonArray2 = [
      {
        text: "解除关联",
        key: "remove"
      }
    ];
    let addingStationArray = [
      {
        label: "机构名称",
        keyName: "name",
        type: "text",
        isDisable: true
      },
      {
        label: "选择员工",
        keyName: "employeeName",
        type: "select",
        children: []
      }
    ];
    if (ROLE_AGENT || ROLE_STATION_MANAGER) {
      tableButtonArray1.push({
        text: "设为主管视光师",
        key: "director"
      });
      tableButtonArray2.push({
        text: "取消主管",
        key: "undirector"
      });
      addingStationArray.push({
        label: "",
        keyName: "director",
        type: "checkbox",
        children: [
          {
            label: "设为主管",
            keyName: "设为主管",
            checked: false
          }
        ]
      });
    }
    if (ROLE_STATION_MANAGER) {
      newEmployeeRoles.push({
        label: "主管",
        keyName: "ROLE_STATION_MANAGER"
      });
    }
    const stationDirector = this.$cookie.get("stationDirector") == "true";

    return {
      ROLE_SUPER_ADMIN,
      ROLE_AGENT,
      ROLE_REGION_MANAGER,
      ROLE_STATION_MANAGER,
      stationInfo: {},
      addingStation: false,
      removeStation: false,
      canAgenteAuthorized: true,
      defaultValue: {},
      searchForm: {
        name: "",
        phone: "",
        createdBy: "",
        dateRange: []
      },
      currentPage: 1,
      employeList: [],
      patientList: [],
      buttonArray: [
        {
          text: "编辑",
          key: "edit"
        }
      ],
      tableButtonArray1,
      tableButtonArray2,
      searchInputArray: [
        {
          label: "姓名",
          keyName: "name"
        },
        {
          label: "手机号",
          keyName: "phone"
        },
        {
          label: "开单人",
          keyName: "createdBy"
        }
      ],
      editStation: false,
      addingStationArray,
      formInputArray: [
        {
          label: "机构ID",
          keyName: "stationId",
          type: "text"
        },
        {
          label: "机构名称",
          keyName: "name",
          type: "text"
        },
        {
          label: "所属省份",
          keyName: "districtProvince",
          type: "select",
          children: []
        },
        {
          label: "所属城市",
          keyName: "districtCity",
          type: "select",
          children: []
        },
        {
          label: "地址",
          keyName: "location",
          type: "textarea"
        },
        {
          label: "代理商",
          keyName: "agentId",
          type: "select",
          children: []
        }
      ],
      agentList: [],
      ProvinceList: [],
      employeePageCount: 0,
      employeeActivePage: 1,
      patientPageCount: 0,
      patientActivePage: 1,
      totalElements: 0,
      setDirector: false,
      removeDirector: false,
      stationDirector,
      addingUser: false,
      addingUserInputArray: [
        // {
        //   label: "工号",
        //   keyName: "staffId",
        //   type: "text"
        // },
        {
          label: "姓名",
          keyName: "name",
          type: "text"
        },
        {
          label: "性别",
          keyName: "gender",
          type: "radio",
          children: [
            {
              label: "男",
              keyName: "MALE"
            },
            {
              label: "女",
              keyName: "FEMALE"
            }
          ]
        },
        {
          label: "联系电话",
          keyName: "phone",
          type: "text"
        },
        {
          label: "权限",
          keyName: "auths",
          type: "checkbox",
          children: [
            {
              label: "开单",
              keyName: "ROLE_SALESMAN",
              select: true
            },
            {
              label: "数据统计",
              keyName: "ROLE_DATA_MONITOR",
              select: true
            }
          ]
        },
        {
          label: "角色",
          keyName: "role",
          type: "select",
          children: newEmployeeRoles
        }
      ],
      saleVersionList: [
        {
          name: "专业版",
          price: 1500,
          edit: false
        }
      ]
    };
  },
  created() {
    this.loadData();
    this.loadEmployee();
    this.loadpatient()
  },
  methods: {
    async loadData() {
      const stationId = this.$route.params.stationId;
      let stationData = await this.$http.getStationDetileInfo(stationId);
      stationData.districtProvince = stationData.district.pid.id;
      stationData.districtCity = stationData.district.id;
      this.saleVersionList[0].price = stationData.coursePrice;
      this.stationInfo = stationData;
    },
    async loadpatient() {
      const stationId = this.$route.params.stationId;
      let params = {
        page: this.patientActivePage - 1
        // size: 10
      };
      if (this.searchForm.name) params.name = this.searchForm.name;
      if (this.searchForm.phone) params.phone = this.searchForm.phone;
      if (this.searchForm.createdBy) params.createdBy = this.searchForm.createdBy;
      if (this.searchForm.dateRange && this.searchForm.dateRange[0]) {
        params.start = this.searchForm.dateRange[0];
      }
      if (this.searchForm.dateRange && this.searchForm.dateRange[1]) {
        params.end = this.searchForm.dateRange[1];
      }
      const result = await this.$http.agentStationEmployeeList(
        stationId,
        "patient",
        params
      );
      if (result && result.content) {
        let newTableData = [];
        result.content.forEach(item => {
          let birth;
          if (item.birth && typeof item.birth === "string") {
            birth = item.birth.split(".")[0];
          } else {
            birth = item.birth ? new Date(item.birth) : new Date();
          }
          newTableData.push({
            createdAt: moment(item.createdAt).format("YYYY-MM-DD"),
            age: moment().diff(birth, "year"),
            remark: item.remark,
            name: item.user.name,
            gender: MapGender(item.user.gender),
            phone: item.user.phone,
            trainingCount: `${item.finishedTrainingCount ||
              0}/${item.trainingCount || 0}`,
            createdBy: item.createdBy,
            userId: item.user.id,
            notice: item.trainingCount - item.finishedTrainingCount <= 10,
            courseConfigured: item.courseConfigured,
            visionDisease: MapVisionDisease(item.visionDisease),
            treatmentStage: MapTreatmentStage(item.treatmentStage)
          });
        });
        this.patientList = newTableData;
        this.patientPageCount = result.totalPages;
        this.totalElements = result.totalElements;
      }
    },
    async loadEmployee() {
      let params = {
        page: this.employeeActivePage - 1
      };
      const stationId = this.$route.params.stationId;
      const result = await this.$http.agentStationEmployeeList(
        stationId,
        "staff",
        params
      );
      if (result) {
        let newTableData = [];
        result.forEach(item => {
          const roles = item.roles
            .map(o => {
              return MapEmployeeRoles(o);
            })
            .filter(o => o);
          newTableData.push({
            remark: item.remark,
            name: item.user.name,
            gender: MapGender(item.user.gender),
            phone: item.user.phone,
            staffId: item.user.staffId,
            userId: item.user.id,
            isDirector: item.isDirector,
            roles: roles.join(","),
            optoTestingCount: item.optoTestingCount || 0
          });
        });
        this.employeList = newTableData;
        this.employeePageCount = result.totalPages;
      }
      if (this.ROLE_AGENT || this.stationDirector || this.ROLE_STATION_MANAGER) {
        const AgenteAuthorizedList = await this.$http.agentStationSubordinateEmployeeList();
        const xorList = xorBy(
          AgenteAuthorizedList.content,
          this.employeList,
          "userId"
        );
        if (xorList.length > 0) {
          let tempChildren = [];
          xorList.forEach(o =>
            tempChildren.push({
              label: o.name,
              keyName: o.userId
            })
          );
          let tempFormInputArray = this.addingStationArray.map(o => {
            if (o.keyName == "employeeName") {
              o.children = tempChildren;
            }
            return o;
          });

          this.addingStationArray = tempFormInputArray;
        } else {
          this.canAgenteAuthorized = false;
        }
      }
    },
    async removeByID() {
      const row = this.defaultValue;
      const stationId = this.$route.params.stationId;

      const postData = {
        stationUUID: stationId,
        userId: row.userId
      };
      let result = await this.$http.updateAgenteEmployeeAuthorized(
        "remove",
        postData
      );
      if (result === "success") {
        this.loadEmployee();
      }
    },
    async setDirectorByID() {
      const row = this.defaultValue;
      const stationId = this.$route.params.stationId;

      const postData = {
        stationUUID: stationId,
        userId: row.userId,
        isDirector: true
      };
      let result = await this.$http.updateStaffDirector(postData);
      if (result === "success") {
        this.loadEmployee();
      }
    },
    async removeDirectorByID() {
      const row = this.defaultValue;
      const stationId = this.$route.params.stationId;

      const postData = {
        stationUUID: stationId,
        userId: row.userId,
        isDirector: false
      };
      let result = await this.$http.updateStaffDirector(postData);
      if (result === "success") {
        if (row.userId === this.$cookie.get("id")) {
          sessionStorage.clear();
          quit();
        } else {
          this.loadEmployee();
        }
      }
    },
    async onAddingNew(data) {
      if (data) {
        const stationId = this.$route.params.stationId;
        const postData = {
          stationUUID: stationId,
          userId: data.employeeName
        };
        if (data.director && data.director.length > 0) {
          postData.isDirector = true;
        }
        let result = await this.$http.updateAgenteEmployeeAuthorized(
          "add",
          postData
        );
        this.addingStation = false;
        if (result === "success") {
          this.loadEmployee();
        }
      }
    },
    async loadProvice() {
      let ProvinceList;
      if (this.ROLE_REGION_MANAGER) {
        ProvinceList = await this.$http.getProvinceList("regionManager");
      }
      if (ProvinceList.length > 0) {
        this.ProvinceList = ProvinceList.map(o => {
          return {
            label: o.name,
            keyName: o.id,
            sons: o.sons,
            id: o.id,
            name: o.name
          };
        });
      }
      const agentList = await this.$http.regionGetAgentListforAddStation({
        // districtIds: this.stationInfo.districtCity,
        size:500
      });
      if (agentList && agentList.content) {
        let temp = [];
        agentList.content.forEach(o => {
          temp.push({
            keyName: o.user.id,
            label: o.companyName,
            districts: o.districts
          });
        });
        this.agentList = temp;
      }
      this.editStation = true;
    },
    willAddingStation() {
      if (this.canAgenteAuthorized) {
        this.addingStation = true;
      } else {
        alert("暂时没有可以关联的员工了！");
      }
    },
    onOperationClick(row, key) {
      this.defaultValue = row;
      console.log("row", row, key);
      if (key === "remove") {
        const userId = this.$cookie.get("id");
        if (row.userId !== userId) {
          this.removeStation = true;
        } else {
          this.$message.warning("您不能解除自己的关联！");
        }
      } else if (key === "director") {
        this.setDirector = true;
      } else {
        this.removeDirector = true;
      }
    },
    onSwitch(tabs) {
      if (tabs.label === "患者列表") {
        this.loadpatient();
      }
    },
    async onEditAccount(form) {
      const stationId = this.$route.params.stationId;
      const updateData = {
        stationUUID: stationId,
        stationId: form.stationId,
        name: form.name,
        districtId: form.districtCity,
        location: form.location,
        agentId: form.agentId
      };
      if (
        this.stationInfo.agentId &&
        form.agentId !== this.stationInfo.agentId
      ) {
        console.log("-->>>");
        this.$confirm(
          `您确定替换原有代理商${this.stationInfo.companyName}吗?`,
          "检测到代理商发生变化",
          {
            confirmButtonText: "确定",
            showCancelButton: false,
            center: true,
            customClass: "paymentConfirmClass"
          }
        )
          .then(async () => {
            let result = await this.$http.regionEditStation(updateData);
            if (result === "success") {
              this.loadData();
              this.$message({
                type: "success",
                message: "操作成功!"
              });
            }
          })
          .catch(() => {
            this.$message({
              type: "success",
              message: "您已取消更改操作!"
            });
          });
      } else {
        let result = await this.$http.regionEditStation(updateData);
        if (result === "success") {
          this.loadData();
        }
      }
    },
    onSearch(row) {
      this.searchForm.name = row.name;
      this.searchForm.phone = row.phone;
      this.searchForm.createdBy = row.createdBy
      this.patientActivePage = 1;
      this.loadpatient();
    },
    onEditClick() {
      this.loadProvice();
    },
    onPatientClicked(row) {
      console.log("row = " + JSON.stringify(row));
      this.$router.push({
        path: `/index/patientManagement/patientManagementDetail/${row.userId}/${this.$route.params.stationId}`
      });
    },
    employeeHandleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    employeeHandleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.employeeActivePage = val;
      this.loadEmployee();
    },
    patientHandleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    patientHandleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.patientActivePage = val;
      this.loadpatient();
    },
    async onUpdateAccount(formdata) {
      console.log(">>>>>>>");
      const updateData = cloneDeep(formdata);
      // const stationId = this.$route.params.stationId;
      updateData.stationUUID = this.$route.params.stationId;
      const type = "addAccount";
      let result = await this.$http.updateAgentAccountInfo(type, updateData);
      if (result === "success") {
        this.loadEmployee();
      }
    },
    async onEditPrice(row) {
      row.edit = false;
      const data = {
        coursePrice: row.price
      };
      const result = await this.$http.editHospitalPrice(
        data,
        this.$route.params.stationId
      );
      if (result) {
        this.$message.success("操作成功！");
      } else {
        row.price = 1500;
      }
      row.edit = false;
    },
    cancelEditPrice(row) {
      row.price = 1500;
      row.edit = false;
    }
  }
};
</script>
<template>
  <div class="stationDetileIndex">
    <el-card class="box-card basicInfo" shadow="never">
      <div slot="header" class="clearfix">
        <span class="cardTitleText">基本信息</span>
        <DialogForm
          v-if="editStation"
          formTitle="编辑医疗机构"
          :formInputArray="formInputArray"
          @close="editStation = false"
          @submitForm="onEditAccount"
          :defaultValue="stationInfo"
          :ProvinceList="ProvinceList"
          :agentList="agentList"
        />
        <textButtonGroup
          v-if="ROLE_REGION_MANAGER"
          class="editButton"
          :buttonArray="buttonArray"
          @onOperationClick="loadProvice"
        />
      </div>
      <div class="text item">
        <el-row :gutter="20">
          <!-- <el-col :span="8">
            <div class="grid-content bg-purple">机构ID: {{stationInfo.stationId}}</div>
          </el-col> -->
          <el-col :span="8">
            <div class="grid-content bg-purple">代理商: {{stationInfo.companyName}}</div>
          </el-col>
          <el-col :span="8">
            <div
              class="grid-content bg-purple"
            >所属城市: {{stationInfo.district && stationInfo.district.name}}</div>
          </el-col>
          <el-col :span="8">
            <div
              class="grid-content bg-purple"
            >剩余疗程数/单次训练数: {{stationInfo.remainingTreatmentCount}}/{{stationInfo.singleSaleCount}}</div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content bg-purple">机构名称: {{stationInfo.name}}</div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">地址: {{stationInfo.location}}</div>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <div class="line"></div>
    <el-tabs class="border-card detailTab" @tab-click="onSwitch">
      <el-tab-pane label="患者列表">
        <span class="datePickerView">
          创建时间：
          <el-date-picker
            v-model="searchForm.dateRange"
            size="medium"
            class="dateRange"
            type="daterange"
            range-separator="至"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </span>
        <searchForm
          class="searchForm"
          showSearch
          @onSearch="onSearch"
          :textInputArray="searchInputArray"
        />

        <div class="statistics">
          <i class="el-icon-info totalResult"></i>
          查询结果：
          <span class="totalResult">{{totalElements}}</span> 个
        </div>
        <el-table
          :data="patientList"
          class="employeTable"
          @row-click="onPatientClicked"
          :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
          :cell-style="{'padding-left': '5px'}"
        >
          <el-table-column prop="label" align="left" label width="90">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.notice" size="mini" type="danger">建议充值</el-tag>
              <el-tag v-if="scope.row.courseConfigured === false" size="mini" type="danger">待配置</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" align="left" label="创建时间" width="120"></el-table-column>
          <el-table-column prop="name" align="left" label="姓名" width="120"></el-table-column>
          <el-table-column prop="gender" align="left" label="性别" width="80"></el-table-column>
          <el-table-column prop="phone" align="left" label="联系电话" width="120"></el-table-column>
          <el-table-column prop="age" align="left" label="年龄" width="80"></el-table-column>
          <el-table-column prop="trainingCount" align="left" label="训练项" min-width="100"></el-table-column>
          <el-table-column prop="visionDisease" align="left" label="类型" min-width="55"></el-table-column>
          <el-table-column prop="treatmentStage" align="left" label="训练阶段" min-width="85"></el-table-column>
          <el-table-column prop="createdBy" align="left" label="开单人" min-width="100"></el-table-column>
        </el-table>
        <PagenationContainer v-if="patientPageCount > 1">
          <el-pagination
            @size-change="patientHandleSizeChange"
            background
            @current-change="patientHandleCurrentChange"
            :current-page="patientActivePage"
            :page-count="patientPageCount"
            layout="prev, pager, next, jumper"
          ></el-pagination>
        </PagenationContainer>
      </el-tab-pane>
      <el-tab-pane label="员工列表">
        <DialogForm
          v-if="addingStation"
          formTitle="关联员工"
          :formInputArray="addingStationArray"
          @close="addingStation = false"
          @submitForm="onAddingNew"
          :defaultValue="stationInfo"
        />
        <DialogForm
          v-if="removeStation"
          formTitle="确认解除关联？"
          :defaultValue="stationInfo"
          @close="removeStation = false"
          @submitForm="removeByID"
          confirmButton="确认"
        />
        <DialogForm
          v-if="setDirector"
          formTitle="确认设为主管视光师？"
          :defaultValue="stationInfo"
          @close="setDirector = false"
          @submitForm="setDirectorByID"
          confirmButton="确认"
        />
        <DialogForm
          v-if="removeDirector"
          formTitle="确认解除主管视光师？"
          :defaultValue="stationInfo"
          @close="removeDirector = false"
          @submitForm="removeDirectorByID"
          confirmButton="确认"
        />
        <DialogForm
          v-if="addingUser"
          formTitle="添加账号"
          :formInputArray="addingUserInputArray"
          @close="addingUser = false"
          @submitForm="onUpdateAccount"
          keyOperation="addAccount"
        />
        <elementButton
          v-if="ROLE_AGENT || stationDirector"
          size="middle"
          class="linkEmployeeButton"
          @click="willAddingStation"
        >关联员工</elementButton>
        <elementButton
          v-if="stationDirector"
          size="middle"
          class="linkEmployeeButton"
          @click="addingUser = true"
        >添加员工</elementButton>
        <el-table
          :data="employeList"
          class="employeTable"
          :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
          :cell-style="{'padding-left': '5px'}"
        >
          <!-- <el-table-column prop="staffId" align="left" label="工号" width="120"></el-table-column> -->
          <el-table-column prop="name" align="left" label="员工姓名" width="150"></el-table-column>
          <el-table-column prop="gender" align="left" label="性别" width="70"></el-table-column>
          <el-table-column prop="phone" align="left" label="联系电话" width="150"></el-table-column>
          <el-table-column prop="roles" align="left" label="角色" width="120"></el-table-column>
          <el-table-column prop="optoTestingCount" label="视功能检测数" width="120"></el-table-column>
          <el-table-column prop="remark" align="left" label="备注"></el-table-column>
          <el-table-column
            v-if="ROLE_AGENT || stationDirector"
            prop="operation"
            align="left"
            label="操作"
            min-width="180"
          >
            <template slot-scope="scope">
              <textButtonGroup
                v-if="scope.row.isDirector"
                :buttonArray="tableButtonArray2"
                :rowData="scope.row"
                @onOperationClick="onOperationClick"
              />
              <textButtonGroup
                v-else
                :buttonArray="tableButtonArray1"
                :rowData="scope.row"
                @onOperationClick="onOperationClick"
              />
            </template>
          </el-table-column>
        </el-table>
        <PagenationContainer v-if="employeePageCount > 1">
          <el-pagination
            @size-change="employeeHandleSizeChange"
            background
            @current-change="employeeHandleCurrentChange"
            :current-page="employeeActivePage"
            :page-count="employeePageCount"
            layout="prev, pager, next, jumper"
          ></el-pagination>
        </PagenationContainer>
      </el-tab-pane>
      <el-tab-pane label="销售版本">
        <el-table
          :data="saleVersionList"
          class="employeTable"
          :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
          :cell-style="{'padding-left': '5px'}"
        >
          <el-table-column prop="name" align="left" label="版本名称" width="120"></el-table-column>
          <el-table-column prop="price" align="left" label="建议售价（元）" min-width="120">
            <template slot-scope="scope">
              <span v-if="!scope.row.edit" class="patientRemark">
                {{scope.row.price}}
                <i
                  v-if="ROLE_AGENT"
                  @click.stop="scope.row.edit = true"
                  class="el-icon-edit"
                />
              </span>
              <span v-else>
                <el-input-number
                  v-model="scope.row.price"
                  style="width: 120px"
                  :min="1"
                  :max="100000"
                  :controls="false"
                />
                <el-button type="primary" size="mini" @click="onEditPrice(scope.row)">保存</el-button>
                <el-button size="mini" @click="cancelEditPrice(scope.row)">取消</el-button>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.stationDetileIndex {
  background-color: #f5f6f7;
  .basicInfo {
    margin: 15px 0;
  }

  .location {
    float: right;
  }

  .el-row {
    display: flex;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .cardTitleText {
    font-size: 16px;
    font-weight: bold;
  }
  .el-col {
    align-self: center;
    border-radius: 4px;
  }

  .bg-purple-dark {
    background: #99a9bf;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    padding: 10px 0px;
    border-radius: 4px;
  }

  .el-pagination {
    text-align: center;
    margin-top: 10px;
  }

  .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both;
  }

  .el-tabs--border-card {
    box-shadow: none;
    -webkit-box-shadow: none;
  }
  .linkEmployeeButton {
    margin: 10px 2%;
  }
  .employeTable {
    width: 96%;
    margin: 10px auto;
    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
    th > .cell {
      font-weight: bold;
    }
  }
  .detailTab {
    background-color: #ffffff;
    .el-tabs__header {
      margin: auto;
      width: 97%;
    }
    .el-tabs__item {
      margin: 10px auto;
    }
    .el-tabs__content {
      min-height: 400px;
    }
    .datePickerView {
      float: left;
      // height: 70px;
      margin-left: 10px;
      margin-top: 22px;
      .dateRange {
        width: 250px;
        .el-range-editor--mini.el-input__inner {
          height: 36px !important;
        }
        .el-range-editor.is-active,
        .el-range-editor.is-active:hover {
          border-color: #00c1de;
        }
        .el-date-table td.today span {
          color: #00c1de;
        }
      }
    }
  }
  .searchForm {
    // float: left;
    height: 70px;
    margin-top: -10px;
  }
  .statistics {
    float: right;
    margin-right: 30px;
    margin-top: 20px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 22px;
    .totalResult {
      color: #00c1de;
    }
  }

  .editButton {
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/medicalEstablishment/organizationDetail.vue